import { Field, ErrorMessage, useField  } from "formik";
import React from "react";
import { selectDTO } from "../../models/Home.model";
import ErrorText from "./ErrorText";

export const SelectCombo = (props: propsSelectCombo) => {

const [field, meta] = useField(props.name); //CACHA LOS ERRORES      
const {label, name, data,  clase, textoSeleccion } = props;    
    return (
        <div className="form-group">
            {label ? <label htmlFor={name}>{label}</label> : null }
            <Field as="select" id={name} name={name} className={`${clase} ${meta.touched && meta.error && 'is-invalid'}`}  onChange={(e:any) => { props.handleChange(e) } }>
                <option value="" style={{color: "rgba(0, 0, 0, 0.5)"}}>{textoSeleccion}</option>  
                {data.length !== undefined  && data.length > 0 &&  
                    data.map( 
                        elemento =><option key={elemento.id} value={elemento.id}>{elemento.texto} </option>   
                    )
                }   
                        
            </Field>
            <ErrorMessage name={field.name}>{ mensaje =>  
                <ErrorText mensaje={mensaje} />
            }</ErrorMessage>
        </div> 
    )
}

interface propsSelectCombo{
    label: string,
    clase:string,
    name: string,
    data: selectDTO[],
    handleChange:any,
    textoSeleccion: string
}